import React__default from "react";
import clsx from "clsx";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { Image } from "../../image/image.mjs";
import { ObjectFit } from "../../object-fit/object-fit.mjs";
import { Tag } from "../../tag/tag.mjs";
import { CardContext } from "../card/card.mjs";
const CardContent = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React__default.createElement(CardContentResponsive, { ...rest, responsive }) : /* @__PURE__ */ React__default.createElement(CardContentInner, { ...rest });
};
const CardContentResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React__default.createElement(CardContentInner, { ...rest, ...responsiveProps });
};
const CardContentInner = (props) => {
  const { padding } = React__default.useContext(CardContext);
  const { children, className, elementRef, backgroundImage, borderRadius, style, tagTop, hideTagTop, background, theme } = props;
  const contentPadding = props.padding || padding;
  const classNames = clsx(
    "card__content",
    typeof contentPadding === "string" ? "card__content--padding-".concat(contentPadding) : {
      "card__content--padding-medium": true,
      ["card__content--padding-horizontal-".concat(contentPadding.right)]: contentPadding.right === contentPadding.left && !!contentPadding.right,
      ["card__content--padding-vertical-".concat(contentPadding.top)]: contentPadding.top === contentPadding.bottom && !!contentPadding.top,
      ["card__content--padding-left-".concat(contentPadding.left)]: contentPadding.right !== contentPadding.left && !!contentPadding.left,
      ["card__content--padding-right-".concat(contentPadding.right)]: contentPadding.right !== contentPadding.left && !!contentPadding.right,
      ["card__content--padding-top-".concat(contentPadding.top)]: contentPadding.top !== contentPadding.bottom && !!contentPadding.top,
      ["card__content--padding-bottom-".concat(contentPadding.bottom)]: contentPadding.top !== contentPadding.bottom && !!contentPadding.bottom
    },
    typeof borderRadius === "string" ? "card__content--border-radius-".concat(borderRadius) : {
      ["card__content--border-radius-top-".concat(borderRadius == null ? void 0 : borderRadius.top)]: !!(borderRadius == null ? void 0 : borderRadius.top),
      ["card__content--border-radius-right-".concat(borderRadius == null ? void 0 : borderRadius.right)]: !!(borderRadius == null ? void 0 : borderRadius.right),
      ["card__content--border-radius-bottom-".concat(borderRadius == null ? void 0 : borderRadius.bottom)]: !!(borderRadius == null ? void 0 : borderRadius.bottom),
      ["card__content--border-radius-left-".concat(borderRadius == null ? void 0 : borderRadius.left)]: !!(borderRadius == null ? void 0 : borderRadius.left)
    },
    {
      "card__content--with-tag": !!tagTop,
      "card__content--with-background-image": !!backgroundImage,
      [background ? getBackgroundColorClass(background) : ""]: !!background
    },
    className
  );
  const topTags = React__default.useMemo(() => {
    if (tagTop && (Array.isArray(tagTop) || typeof tagTop === "object")) {
      return Array.isArray(tagTop) ? tagTop : [tagTop];
    }
    return [];
  }, [tagTop]);
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames, ref: elementRef, style, "data-theme": theme }, tagTop && /* @__PURE__ */ React__default.createElement("div", { className: "card__content-tag-wrapper" }, /* @__PURE__ */ React__default.createElement("div", { className: clsx("card__content-tag-inner", { "is-hidden": !!hideTagTop }) }, Array.isArray(topTags) && topTags.map((tag, index) => {
    var _a;
    return /* @__PURE__ */ React__default.createElement(Tag, { key: (_a = tag.id) != null ? _a : index, className: "card__content-tag", ...tag, size: "tiny" });
  }))), backgroundImage && /* @__PURE__ */ React__default.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center", className: "card__content-object-fit" }, /* @__PURE__ */ React__default.createElement(
    Image,
    {
      ...backgroundImage,
      className: clsx("card__content-background-image", backgroundImage.className),
      pictureClassName: "card__content-background-image-picture"
    }
  )), children);
};
export {
  CardContent,
  CardContentResponsive
};
